import { getDefaultMargin, getDefaultMarginOverlay, getDefaultWidthOverlay } from '../utils'

export const TextDesignSettings = {
  // dimenstions
  'text-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['100%'],
    desktop: ['100%'],
    tv: ['100%'],
    overflowSetting: getDefaultWidthOverlay,
  },

  // typography
  'text-design-typography': {
    phone: {
      typography: 'Body Medium',
    },
    'phone-landscape': {
      typography: 'Body Medium',
    },
    tablet: {
      typography: 'Body Medium',
    },
    'tablet-landscape': {
      typography: 'Body Medium',
    },
    desktop: {
      typography: 'Body Medium',
    },
    tv: {
      typography: 'Body Medium',
    },
  },

  // spacing
  'text-design-padding': {
    phone: getDefaultMargin([0]),
    'phone-landscape': getDefaultMargin([0]),
    tablet: getDefaultMargin([0]),
    'tablet-landscape': getDefaultMargin([0]),
    desktop: getDefaultMargin([0]),
    tv: getDefaultMargin([0]),
  },
  'text-design-margin': {
    phone: getDefaultMargin(),
    'phone-landscape': getDefaultMargin(),
    tablet: getDefaultMargin(),
    'tablet-landscape': getDefaultMargin(),
    desktop: getDefaultMargin(),
    tv: getDefaultMargin(),
    overflowSetting: getDefaultMarginOverlay,
  },

  // alignment
  'text-design-comp-h-align': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'text-design-h-align': {
    phone: 'start',
    'phone-landscape': 'start',
    tablet: 'start',
    'tablet-landscape': 'start',
    desktop: 'start',
    tv: 'start',
  },

  // color
  'text-design-color': {
    dark: 'adaptive',
    light: 'adaptive',
  },
  'text-design-color-solid': {
    dark: 'primary-0',
    light: 'primary-0',
  },
  'text-design-color-start-gradient': {
    dark: 'primary-20',
    light: 'primary-60',
  },
  'text-design-color-end-gradient': {
    dark: 'primary-60',
    light: 'primary-20',
  },
  'text-design-color-gradient-direction': {
    dark: 'to-right',
    light: 'to-right',
  },
}
